// YERİ: src/app/core/auth/device-id.ts
//
// Tarayıcı başına kalıcı, rastgele bir kimlik. Sunucu bunu X-Device-Id
// başlığında görür; "aktif oturumlarım" listesi, "yeni cihazdan giriş"
// uyarısı ve çalıntı refresh token tespiti buna dayanır.
//
// NEDEN MAC DEĞİL: MAC adresi 2. katmanda kalır, ilk yönlendiriciyi geçmez —
// hiçbir web sunucusu göremez. Cihaz ayrımı için elimizdeki tek makul araç bu.
//
// NEDEN ÇEREZ DEĞİL: çerez her isteğe otomatik gider ve CSRF yüzeyi açar;
// karşılığında bize bir şey kazandırmaz. İstemci zaten Authorization başlığı
// taşıyor, bir başlık daha ucuz.
//
// İÇERİĞİ: tamamen anlamsız rastgele bir değer. Kişisel veri taşımaz,
// parmak izi değildir — kullanıcı depolamayı temizlerse sıfırlanır.

import { LocalStorage } from '@/app/core/local-storage/local-storage';

const DEVICE_ID_KEY = 'melland_device_id';

/** Var olanı döner, yoksa üretip saklar. Üretilemezse null (sunucu tolere eder). */
export function getOrCreateDeviceId(storage: LocalStorage): string | null {
  try {
    const existing = storage.getItem(DEVICE_ID_KEY);
    if (existing && existing.length >= 8) return existing;

    const id = generateId();
    storage.setItem(DEVICE_ID_KEY, id);
    return id;
  } catch {
    // Gizli sekme / depolama kapalı. Kimlik göndermeyiz; sunucuda DeviceId
    // null kalır, cihaz bağı kurulmaz ama giriş ENGELLENMEZ.
    return null;
  }
}

function generateId(): string {
  const c = globalThis.crypto as Crypto | undefined;

  if (c?.randomUUID) return c.randomUUID();

  if (c?.getRandomValues) {
    const bytes = new Uint8Array(16);
    c.getRandomValues(bytes);
    return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  }

  // Son çare: kriptografik değil, ama burada gizlilik değil benzersizlik gerekiyor.
  return `d${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`;
}
